<template>
  <div :class="classList" class="item-selector-option">
    <button class="select-button" @click="handleClickSelectButton">
      <img :src="imageUrl" class="icon" />
      <div class="meta">
        <h4 class="name">{{ name }}</h4>
      </div>
    </button>
    <div v-if="canRemove" class="action">
      <sc-button :icon="true" variant="clean" @click="handleClickRemoveButton">
        <img src="/static/icons/close-red.svg" />
      </sc-button>
    </div>
  </div>
</template>

<script>
import ScButton from "@/lib/components/ScButton"

export default {
  components: {
    ScButton,
  },
  props: {
    name: {
      type: null,
      default: undefined,
    },
    imageUrl: {
      type: null,
      default: undefined,
    },
    canSelect: {
      type: null,
      default: undefined,
    },
    canRemove: {
      type: null,
      default: undefined,
    },
  },
  computed: {
    classList() {
      return { selectable: this.canSelect }
    },
  },
  methods: {
    handleClickSelectButton() {
      this.$emit("select")
    },
    handleClickRemoveButton() {
      this.$emit("remove")
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
$logoSize: 48px;
$padding: 10px ($space / 2);

.item-selector-option {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr auto;

  padding: $padding;

  font-family: "Sukhumvit Tadmai";

  > .select-button {
    cursor: default;
    user-select: text;
  }

  &.selectable {
    padding: 0;

    > .select-button {
      padding: $padding;
      cursor: pointer;
    }

    &:hover {
      background: #efefef;
    }
  }

  > .action {
    align-self: center;
  }
}

.select-button {
  display: flex;
  flex-flow: row nowrap;

  border: 0;
  padding: 0;
  outline: 0;
  min-width: 0;

  background: transparent;

  > .icon {
    margin-top: 5px;

    flex: 0 0 $logoSize;
  }

  > .meta {
    padding-left: 20px;
    display: block;

    flex-grow: 1;

    &:not(:last-child) {
      padding-right: 20px;
    }
  }
}

.icon {
  display: block;

  border-radius: 8px;
  width: $logoSize;
  height: $logoSize;
}

.meta {
  min-width: 0;

  > .desc {
    overflow: hidden;
    height: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  > .type {
    overflow: hidden;
    height: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.meta .name {
  margin: 0;
  font-size: 0.9rem;
}

.meta p {
  font-size: 0.8rem;
  color: #777;
}

.meta .name,
.meta p {
  text-align: left;
  line-height: 1.6;
}

.title {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;

  > .provider {
    padding-left: 15px;
  }
}

.provider {
  margin-top: 3px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  > .logo {
    margin-right: 8px;

    border-radius: $border-radius;
    width: 20px;
    height: 20px;
  }

  > .name {
    font-size: 0.8rem;
    color: black;
  }
}
</style>
